import React  from "react";
import PropTypes from "prop-types";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import st from "core/shared-translations";
import mt from 'core/message-translations';
import classes from "./clientedit.scss";
import BoxedContainer from 'components/boxed-container-view';
import { AddFilledIcon ,PersonOutlinedIcon, EditOutlinedIcon, TrashOutlinedIcon, CopyOutlinedIcon } from "@getgo/chameleon-icons/react";
import {
  AlertV2,
  DataTableRowV2,
  DataTableV2,
  DataTableHeaderCellV2,
  DataTableCellV2,
  IconButton,
  TextBadge,
  Button,
  InputField,
  TextField,
  Typography,
  Checkbox,
  TooltipV3,
  Switch
 } from "@getgo/chameleon-web-react-wrapper";
import { Box } from "@mui/material";
import ResponsiveDialog from 'components/dialog-view.js';
import NudgeBanner from 'components/nudge-banner';
import environment from "lib/environment";

const cgpUrl = environment.get().cgp_url;

const t = defineMessages({
 "create-token.active.status": {
    id: "create-token.active.status",
    defaultMessage: "Active Status",
    description: "Field label for active status input",
  },
  "create-secret.edit.status.disable": {
    id: "create-secret.edit.status.disable",
    defaultMessage: " After you disable this secret, integrations using it will no longer work",
    description: "Field label for user name input",
  },

  "client-secret.title": {
    id: "client-secret.title",
    defaultMessage: "You can create up to 6 secrets, but only 3 can be active.",
    description: "Sub title for secrets details",
  },
  "client-secret.edit.title": {
    id: "client-secret.edit.title",
    defaultMessage: "Edit this secret",
    description: "Title for secrets edit",
  },
  "client-secret.title.disable.max-secrets": {
    id: "client-secret.title.disable.max-secrets",
    defaultMessage: "You’re at the maximum number of secrets. To create a new secret, you need to delete an existing one.",
    description: "Sub title for secrets details when it's disable",
  },
  "client-secret.title.disable.max-active-secrets": {
    id: "client-secret.title.disable.max-active-secrets",
    defaultMessage: "You have the max number of active secrets. To create a new secret, disable an existing one first.",
    description: "Sub title for secrets details when active secret is 3",
  },
  'client-secret.create.title': {
    id: 'client-secret.create.title',
    defaultMessage: 'Add secret',
    description: 'Title for editing a client secret in client details',
  },
  'client-secret.table.title1': {
    id: 'client-secret.table.title1',
    defaultMessage: 'Name',
    description: 'Table Secret-Title 1',
  },
  'client-secret.table.title2': {
    id: 'client-secret.table.title2',
    defaultMessage: 'Created',
    description: 'Table Secret-Title 2',
  },
  'client-secret.table.title3': {
    id: 'client-secret.table.title3',
    defaultMessage: 'Status',
    description: 'Table Secret-Title 3',
  },
  'client-secret.table.title4': {
    id: 'client-secret.table.title4',
    defaultMessage: 'Actions',
    description: 'Table Secret-Title 4',
  },
  'client-secret.delete-button.text': {
    id: 'client-secret.delete-button.text',
    defaultMessage: 'Delete this secret',
    description: 'Client secret delete button text',
  },
  'client-secret.create-modal.title': {
    id: 'client-secret.create-modal.title',
    defaultMessage: 'Add a secret',
    description: 'Title for create secret modal',
  },
  'client-secret.create-modal.info': {
    id: 'client-secret.create-modal.info',
    defaultMessage: 'Name your secret to make it easier to identify.',
    description: 'Info for create secret input',
  },
  'client-secret.create-modal.input.label': {
    id: 'client-secret.create-modal.input.label',
    defaultMessage: 'Secret name',
    description: 'label for create secret input',
  },
  'client-secret.create-modal-Cta-button.next': {
    id: 'client-secret.create-modal-Cta-button.next',
    defaultMessage: 'Next: Copy secret',
    description: 'label for create secret Next button',
  },
  'client-secret.create-modal-copy-secret.title': {
    id: 'client-secret.create-modal-copy-secret.title',
    defaultMessage: 'Copy and store secret',
    description: 'heading for copy secret modal',
  },
  'client-secret.create-modal-copy-secret.subtitle': {
    id: 'client-secret.create-modal-copy-secret.subtitle',
    defaultMessage: 'This secret will only be shown once. Copy it and store it in a secure place.',
    description: 'sub-heading for copy secret modal',
  },
  'client-secret.create-modal-copy-secret.second-subtitle': {
    id: 'client-secret.create-modal-copy-secret.second-subtitle',
    defaultMessage: 'Secret',
    description: 'second heading for copy secret modal',
  },
  'client-edit.credentials.client.new.secret.copy.confirm': {
    id: 'client-edit.credentials.client.new.secret.copy.confirm',
    defaultMessage: 'I’ve copied and stored the secret.',
    description: 'confirm secret copied label for checkbox',
  },
  'client-secret.active.status-value': {
    id: 'client-secret.active.status-value',
    defaultMessage: 'Active',
    description: 'label for active status value',
  },
  'client-secret.inactive.status-value': {
    id: 'client-secret.inactive.status-value',
    defaultMessage: 'Inactive',
    description: 'label for disable status value',
  },
  'client-secret-info.delete': {
    id: 'client-secret-info.delete',
    defaultMessage: 'Only disabled secrets can be deleted',
    description: 'On hover text for delete client secret',
  },
  'client-secret.active-secret-limit': {
    id: 'client-secret.active-secret-limit',
    defaultMessage: 'You can\'t activate this secret because you’ve reached the limit of active secrets.You have to disable another secret to be able to activate this.',
    description: 'Client name already present warning',
  },
  'client-secret.last-active.delete-info': {
    id: 'client-secret.last-active.delete-info',
    defaultMessage: 'Every client needs at least 1 active secret',
    description: 'Message to display when there is only one active secret and user want to delete it',
  },
  'client-secret.last-active.info': {
    id: 'client-secret.last-active.info',
    defaultMessage: 'Every client needs 1 active secret, so this secret needs to be active',
    description: 'Message to display when there is only one active secret and user in edit secret mode',
  },
});

const ClientSecretCreateView = ({
  createModelIsOpen,
  copySecretModelIsOpen,
  openCreateModal,
  closeCreateModal,
  closeCopySecretModal,
  onNextClick,
  updateNewClientSecret,
  openedSecretEdit,
  toggleEditMode,
  onDelete,
  secrets,
  enableCTA,
  onCopy,
  onConfirmSecretCopy,
  statusOnChange,
  clientSecretData,
  updateClientSecretName,
  enableEditCTA,
  onEditSave,
  errors,
  disableCreateSecret,
  validateUserInput,
  currentSecretSubHeading,
  onSort,
  enableSecretDisableAlert,
  isInternalDev = false,
}) => {
  const intl = useIntl();
  const emptyFuc = () => { };
  const noOfColumns = 4;
  const oneActiveSecret = secrets.filter(({active})=>active).length == 1;
  return (
    <Box>
      <BoxedContainer
        title={<FormattedMessage {...st['shared.client-edit.credentials.client.secrets.title']} />}
        buttonIcon={<AddFilledIcon data-testid="addSecretIcon" />}
        buttonText={intl.formatMessage(t["client-secret.create.title"])}
        onClick={openCreateModal}
        disabled={disableCreateSecret}
        boxIcon={<PersonOutlinedIcon color="#000000" />}>
        {currentSecretSubHeading === 'client-secret.title' ?
          <AlertV2 className={classes["clientSecretAlertInfo"]} variant="info">
            <FormattedMessage {...t[currentSecretSubHeading]} />
          </AlertV2> : <AlertV2 style={{marginTop:'15px',marginBottom: '15px'}} variant="warning">
            <FormattedMessage {...t[currentSecretSubHeading]} />
          </AlertV2>}
        <React.Fragment>
          {!!secrets.length &&
            <DataTableV2 data-testid="data-table" className={classes["controlWidth"]}>
              <DataTableRowV2 style={{ borderTop: "none" }}>
                {Array.from({ length: noOfColumns }, (_, index) => (
                  <DataTableHeaderCellV2
                    key={index}
                    {...(index === 0 && { sort: "desc", onSort: onSort })} condensed>
                    <FormattedMessage {...t[`client-secret.table.title${index+1}`]} />
                  </DataTableHeaderCellV2>))}
              </DataTableRowV2>
              {secrets.map(({name,active,createTime,secretId})=>(
                <DataTableRowV2 key={name}>
                  <DataTableCellV2>{name}</DataTableCellV2>
                  <DataTableCellV2>{createTime}</DataTableCellV2>
                  <DataTableCellV2>
                    {!!active ? <TextBadge variant="success">
                      <FormattedMessage {...t['client-secret.active.status-value']} />
                    </TextBadge>:
                    <TextBadge>
                      <FormattedMessage {...t['client-secret.inactive.status-value']} />
                    </TextBadge>}
                  </DataTableCellV2>
                  <DataTableCellV2>
                    <IconButton
                      data-testid="edit-icon"
                      onClick={toggleEditMode(secretId)}>
                      <EditOutlinedIcon color="#2C72DE" />
                    </IconButton>
                    <IconButton
                      id="delete-trigger"
                      data-testid="delete-icon"
                      disabled={!!active}
                      onClick={!active ? onDelete(secretId) : emptyFuc}>
                      <TrashOutlinedIcon color={!active ? "#2C72DE" : undefined} />
                    </IconButton>
                    {active && <TooltipV3 position="bottom-end" triggerId="delete-trigger">
                      <FormattedMessage {...t["client-secret-info.delete"]} />
                    </TooltipV3>}
                  </DataTableCellV2>
                </DataTableRowV2>
              ))}
            </DataTableV2>}
        </React.Fragment>
      </BoxedContainer>
      <ResponsiveDialog
        title={<FormattedMessage {...t["client-secret.edit.title"]} />}
        open={openedSecretEdit === clientSecretData.secretId}
        closable
        onClosed={toggleEditMode(clientSecretData)}
        actions={
          <React.Fragment>
            <Button data-testid="secret-edit-modal-save" disabled={!enableEditCTA} onClick={onEditSave()}>
              <FormattedMessage {...st['shared.save']} />
            </Button>
            <Button
              data-testid="secret-edit-modal-cancelBtn"
              onClick={toggleEditMode(clientSecretData.secretId)}
              variant="tertiary">
              <FormattedMessage {...st["shared.cancel"]} />
            </Button>
          </React.Fragment>
        }
      >
        <TextField
          id="secretEditInput"
          name="name"
          role="textbox"
          title={<FormattedMessage {...t["client-secret.table.title1"]} />}
          onChange={updateClientSecretName}
          value={clientSecretData.name}
          helperText={
            intl.formatMessage(t["client-secret.create-modal.info"])
          }
          fullwidth
          maxLength={25}
          error={
            (errors.name && (intl.formatMessage(mt[errors.name]))) ||
            (errors.longEditSecret && errors.longEditSecret)
          }
          dangerCounter={!!errors.longEditSecret && errors.longEditSecret === 'client-edit.secret.length.exceeded'}
          onBlur={() => validateUserInput("name", clientSecretData.name)}
        >
          <FormattedMessage {...t["client-secret.table.title1"]} />
        </TextField>
        <Typography style={{ paddingTop: '15px' }}>
          <FormattedMessage {...t["create-token.active.status"]} />
        </Typography>
        <Switch
          id="switch-trigger"
          onChange={!!errors.status ? emptyFuc : statusOnChange}
          checked={clientSecretData.active}
          disabled={!!errors.status} />
        {!!errors.status &&
          <TooltipV3
            triggerId="switch-trigger"
          >
            {intl.formatMessage(t[errors.status])}
          </TooltipV3>}
        {enableSecretDisableAlert &&
          <AlertV2 variant="warning">
            <Typography>
              <FormattedMessage {...t['create-secret.edit.status.disable']} />
            </Typography>
          </AlertV2>}
      </ResponsiveDialog>
      <ResponsiveDialog
        title={<FormattedMessage {...t["client-secret.create-modal.title"]} />}
        open={createModelIsOpen}
        data-testid="create-secret-modal"
        closable
        onClosed={closeCreateModal}
        actions={
          <React.Fragment>
            <Button disabled={!enableCTA} onClick={onNextClick}>
              <FormattedMessage {...t['client-secret.create-modal-Cta-button.next']} />
            </Button>
            <Button data-testid="createModal-cancel" onClick={closeCreateModal} variant="tertiary">
              <FormattedMessage {...st["shared.cancel"]} />
            </Button>
          </React.Fragment>
        }
      >
        <TextField
          id="name-input"
          data-testid="name-input"
          name="name"
          role="textbox"
          maxLength={25}
          title={<FormattedMessage {...t["client-secret.table.title1"]} />}
          onChange={updateNewClientSecret}
          value={clientSecretData.name}
          helperText={
            intl.formatMessage(t["client-secret.create-modal.info"])
          }
          fullwidth
          error={
            (errors.name && (intl.formatMessage(mt[errors.name]))) ||
            (errors.longEditSecret && errors.longEditSecret)
          }
          dangerCounter={!!errors.longEditSecret && errors.longEditSecret === 'client-edit.secret.length.exceeded'}
          onBlur={() => validateUserInput("name", clientSecretData.name)}
        >
          <FormattedMessage {...t["client-secret.table.title1"]} />
        </TextField>
      </ResponsiveDialog>
      <ResponsiveDialog
        title={<FormattedMessage {...t["client-secret.create-modal.title"]} />}
        open={copySecretModelIsOpen}
        closable
        data-testid="copySecret-modal"
        onClosed={closeCopySecretModal}
        actions={
          <React.Fragment>
            <Button data-testid="copySecret-saveBtn" disabled={!clientSecretData.secretCopied} onClick={closeCopySecretModal}>
              <FormattedMessage {...st['shared.save']} />
            </Button>
            <Button data-testid="copySecret-cancelBtn" onClick={closeCopySecretModal} variant="tertiary">
              <FormattedMessage {...st["shared.cancel"]} />
            </Button>
          </React.Fragment>
        }
      >
        <Box id="confirmDialogBody">
          <React.Fragment>
            <AlertV2 style={{marginBottom: "10px"}} variant="warning">
              <Typography>
                <FormattedMessage {...t['client-secret.create-modal-copy-secret.subtitle']} />
              </Typography>
            </AlertV2>
            <Box className={classes["secretIdSection"]}>
              <Typography style={{paddingBottom: "15px"}} variant="body-medium-strong" color="type-color-default">
                <FormattedMessage {...st['shared.credentials.client.secret.title']} />
              </Typography>
              <Box className={classes["tokenDisplayBg"]}>
                <Typography variant="button-small">
                  {clientSecretData.id}
                </Typography>
                <Box className={`${classes["flexSideSmall"]} ${classes["copyButtonStyle"]}`}>
                  <Button
                    title="copyButton"
                    leadingIcon={<CopyOutlinedIcon color="#2C72DE" />}
                    variant="tertiary"
                    onClick={onCopy(clientSecretData.id)}
                    >
                    <Typography variant="body-small-strong" color="type-color-brand-default">
                      <FormattedMessage {...st['shared.copy']} />
                    </Typography>
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box className="row">
              <Box className="col-xs-12">
                <Box className={classes["copyCheckBox"]}>
                  <Checkbox
                    id="confirmCopy"
                    name="confirmCopy"
                    checked={!!clientSecretData.secretCopied}
                    onChange={onConfirmSecretCopy}
                    >
                    <FormattedMessage {...t['client-edit.credentials.client.new.secret.copy.confirm']} />
                  </Checkbox>
                </Box>
              </Box>
            </Box>
            {isInternalDev &&
              <Box className="row">
                <Box className="col-xs-12">
                  <NudgeBanner
                    messageKey={st['shared.cgp.nudge.created']}
                    url={cgpUrl}
                    linkLabel={st['shared.cgp.link.label']}
                  />
                </Box>
              </Box>}
          </React.Fragment>
        </Box>
      </ResponsiveDialog>
    </Box>
  );
};


ClientSecretCreateView.propTypes = {
  createModelIsOpen: PropTypes.bool.isRequired,
  copySecretModelIsOpen: PropTypes.bool.isRequired,
  openCreateModal: PropTypes.func.isRequired,
  closeCreateModal: PropTypes.func.isRequired,
  closeCopySecretModal: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  secrets: PropTypes.array.isRequired,
  updateNewClientSecret: PropTypes.func.isRequired,
  openedSecretEdit: PropTypes.string.isRequired,
  toggleEditMode: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  enableCTA: PropTypes.bool.isRequired,
  onCopy: PropTypes.func.isRequired,
  onConfirmSecretCopy: PropTypes.func.isRequired,
  statusOnChange: PropTypes.func.isRequired,
  clientSecretData: PropTypes.object.isRequired,
  updateClientSecretName: PropTypes.func.isRequired,
  enableEditCTA: PropTypes.bool.isRequired,
  onEditSave: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  disableCreateSecret: PropTypes.bool.isRequired,
  validateUserInput: PropTypes.func.isRequired,
  currentSecretSubHeading: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  enableSecretDisableAlert: PropTypes.bool.isRequired,
  isInternalDev: PropTypes.bool,
};

export default ClientSecretCreateView;
